import { createSlice } from '@reduxjs/toolkit';
import { createCustomerAsync, createCustomerAsyncBuilder, fetchCustomerAsync, fetchCustomerAsyncBuilder, } from './asyncRequests';
const initialState = {
    data: {},
    loading: false,
    success: false,
    error: '',
};
export const CustomerSlice = createSlice({
    name: 'customerSlice',
    initialState,
    reducers: {
        resetError: (state) => {
            state.error = initialState.error;
        },
    },
    extraReducers: (builder) => {
        createCustomerAsyncBuilder(builder);
        fetchCustomerAsyncBuilder(builder);
    },
});
export const CustomerActions = {
    ...CustomerSlice.actions,
    createCustomerAsync,
    fetchCustomerAsync,
};
export const CustomerReducer = CustomerSlice.reducer;
